import {useCallback} from "react";
import {useHistory} from "react-router-dom";

import type {PressDowndownType} from "./types";

export function useDropdownMenuClickCallback() {
    const history = useHistory();

    const handleClickItem = useCallback(
        ({type, link, target, onPress}: PressDowndownType) => {
            if (type === "internal") {
                history.push(link);
            }

            if (type === "external") {
                window.open(link, target ?? "_blank");
            }

            if (onPress) {
                onPress();
            }
        },
        [history]
    );

    return handleClickItem;
}
